import React from 'react';

const BlackFridayBackgroundGraphics = () => {
  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden select-none">
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(circle at 80% 20%, rgba(250, 204, 21, 0.16) 0%, rgba(225, 29, 72, 0.14) 35%, transparent 65%), radial-gradient(circle at 20% 80%, rgba(56, 189, 248, 0.10) 0%, transparent 60%)'
        }}
      />

      <svg viewBox="0 0 1600 1000" className="w-full h-full object-cover" preserveAspectRatio="xMidYMid slice">
        <defs>
          <linearGradient id="cyberGridGrad" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#FACC15" stopOpacity="0.35" />
            <stop offset="100%" stopColor="#E11D48" stopOpacity="0.05" />
          </linearGradient>
          <filter id="boltGlow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur in="SourceGraphic" stdDeviation="6" />
          </filter>
        </defs>

        {/* High Voltage Lightning Bolt Discharge (Left & Right) */}
        <polygon points="260,0 210,220 280,220 200,480 340,190 270,190" fill="#FACC15" filter="url(#boltGlow)" opacity="0.6" />
        <polygon points="1380,0 1330,240 1400,240 1320,500 1460,210 1390,210" fill="#38BDF8" filter="url(#boltGlow)" opacity="0.5" />

        {/* 3D Perspective Cyber Grid */}
        <g stroke="url(#cyberGridGrad)" strokeWidth="1.5">
          {[0, 200, 400, 600, 800, 1000, 1200, 1400, 1600].map((x, i) => (
            <line key={i} x1="800" y1="520" x2={x} y2="1000" />
          ))}
          {[550, 590, 640, 710, 800, 910].map((y, i) => (
            <line key={i} x1="0" y1={y} x2="1600" y2={y} />
          ))}
        </g>

        {/* Dark Monolith Server Towers */}
        <rect x="80" y="440" width="140" height="560" fill="#141417" stroke="#27272A" strokeWidth="2" />
        <rect x="1380" y="420" width="150" height="580" fill="#141417" stroke="#27272A" strokeWidth="2" />
      </svg>
    </div>
  );
};

export default BlackFridayBackgroundGraphics;
